import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store/index'
import authCheck from './router/authCheck'

require('./bootstrap')

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (Vue.auth.user.authenticated === false && !to.matched.some(record => record.meta.isGuest)) {
    Vue.auth.getUserInfo()
      .then(() => {
        authCheck(to, next)
      })
      .catch((data) => {
        console.log(data)
        Vue.auth.logout()
      })
  } else {
    authCheck(to, next)
  }
})

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js